<template>
    <span v-if="display">
        
        <s-button :icon="label=='' ? 'question' : ''" afterIcon="video" @onclick="openVideo()" :label="label" :theme="theme" />
        
        <div :class="classModal+ ' modalVideo'">
			<div class="modal-background"></div>
  			<div class="modal-card">
	    		<header class="modal-card-head" >
				      <p class="modal-card-title" style="width:90%;text-align:left" >{{name}}</p>	
				      <div style="float:rigth" v-if="close">
				      	<s-button theme="" label="" icon="times-circle" @onclick="close"/>
				      </div>

				</header>
				<section class="modal-card-body">
                   
                    <div style="margin: 10px;text-align:left" v-show="videos.length>1 && videoDisplay==null">
                        <s-button icon="list" @onclick="videoDisplay=null" theme="is-warning" label=""/>
                    </div>
                    <div v-show="videoDisplay!=null">
                        <youtube width="100%" 
                            :video-id="videoDisplay" 
                            :player-vars="playerVars"  
                            :ref="'youtube_'+id"
                            @playing="playing"
                            @paused="paused"
                            @ended="ended"></youtube> 
                        <div v-if="creditOffer && ecouleTime>0 && sendCredit" class="offerCredit">
                            Après {{ecouleTime}} secondes de lecture, cette vidéo vous permettra de gagner 1 crédit
                        </div>
                        <div v-if="ecouleTime<=0 && sendCredit" class="offerCredit">
                            <s-l id="offerVideoCredit">Petanque-app vous offre 1 crédit !!! </s-l>
                        </div>
                    </div>
                    <div v-show="videoDisplay==null">
                        <div v-for="video in videos" style="margin-top: 10px;text-align:left">
                           
                            <s-button
                                afterIcon="film"
                                :label="video.titleButton"
                                @onclick="selectVideo(video.id)"
                                theme="is-info"
                                icon=""
                            />
                        </div>
                    </div>
				</section>
                <footer class="modal-card-foot">
                    <div v-if="videoAdmin" class="footerVideo">
                        ID de la vidéo : {{id}}
                        <div style="margin: 10px">
                        <s-input width="90%" type="name" v-model="name" theme="is-primary is-small" placeholder="Titre" />
                        &nbsp;<s-button icon="save" @onclick="saveNom" label="" theme="is-success is-small"/>
                        </div>
                        <div style="width: 100%">
                            <div style="width: 40%;display:inline-block">
                                <p style="text-align:right;margin: 2px">Titre : 
                                    <s-input width="150px" 
                                        theme="is-primary is-small" type="text" 
                                        v-model="video.title" 
                                        placeholder="Titre de la vidéo"/></p>
                                <p style="text-align:right;margin: 2px,width:100%">
                                    <div style="display: inline-block;width: 50%;text-align:right">
                                    Chapitre : 
                                    </div>
                                    <div style="display: inline-block;text-align:right;width: 50%;">
                                    <s-select
                                        :value="video.chapitre"
                                        :values="chapitres" 
                                        @close="closeModal()" 
                                        theme="is-small"
                                        @select="selectChapitre"
                                        @delete="deleteChapitre"
                                        @add="addChapitre"
                                        @save="saveChapitres"
                                    />
                                    </div>
                                </p>
                                <p style="text-align:right;margin: 2px">Bouton : 
                                    <s-input width="150px" theme="is-primary is-small" type="text" 
                                    v-model="video.titleButton" placeholder="Label du bouton"/></p>
                                
                                <p style="text-align:right;margin: 2px">Id Youtube: 
                                        <s-input  width="150px" theme="is-primary  is-small" type="text" v-model="video.idYouTube" placeholder="Id You Tube"/></p>
                                <p style="text-align:right;margin: 2px">Offre 1 crédit
                                        <select theme="is-primary  is-small" type="text" v-model="video.credit" >
                                            <option value="0">NON</option>
                                            <option value="1">OUI</option>
                                        </select>
                                </p>
                            </div>
                            <div style="width: 60%;display:inline-block;vertical-align:top;text-align:center">
                                <div class="listVideos">
                                    <div v-for="(video,indexVideo) in videos" class="itemVideo">
                                        <div style="float:left">
                                            <s-button @onclick="editVideo(video)" icon="edit" theme="is-warning is-small" label=""/>
                                            &nbsp;
                                            {{video.title}} 
                                        </div>
                                        <div style="float:right">
                                            
                                           <s-button 
                                            :disabled="indexVideo==0"
                                            icon="arrow-up" @onclick="up(indexVideo)" theme="is-small is-primary" label=""/>
                                            &nbsp;
                                        <s-button
                                        :disabled="indexVideo==videos.length-1"
                                        icon="arrow-down" @onclick="down(indexVideo)" theme="is-small is-primary" label=""/>
                                        &nbsp;
                                            &nbsp;
                                            <s-button icon="trash" theme="is-danger is-small" label="" @onclick="deleteVideo(indexVideo)"/>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            <div style="margin-bottom: 20px;margin-left: 10px;width: 90%">
                                <div style="float:left;margin-left: 20px">
                                   <s-button @onclick="addVideo" theme="is-info is-small" icon="plus" label="Ajouter" />
                                   &nbsp;<s-button @onclick="saveVideo" theme="is-success is-small" icon="save" label="Enregistrer" :disabled="video.idYouTube==''"/>
                                   
                                   
                                </div>
                                <div style="float:right">
                                    <s-button @onclick="deleteVideos" theme="is-danger  is-small" icon="trash" label="Supprimer"/>
                                </div>
                                </div>
                        </div>
                        <br/>
                        
                        
                    </div>
                </footer>
  			</div>
         </div>
        
    </span>
</template>
<style scoped>
    .offerCredit {
        background-color: greenyellow;
        color: black;
        font-size: 25px;
        text-align: center;
        font-weight: bolder;
    }
    .footerVideo {
        text-align: left;
        font-size: 14px;
        color: black;
        border: thin solid black;
        width: 100%;
    }
    iframe {
        
    }
    .modalVideo {
        position: fixed;
        z-index: 200;
    }
    .itemVideo {
        width: 90%;
        border: thin solid black;
        padding: 2px;
        height: 35px;
        margin-left: auto;
        margin-right: auto;
    }
    .listVideos {
        height: 150px;
        overflow-y: auto;
        
        width: 100%;
    }
</style>
<script>
import firebase_api from '@/firebase/firebase_api'
import vSelect from 'vue-select'
import "vue-select/src/scss/vue-select.scss";
const { v4: uuidv4 } = require('uuid');
export default {
    props: {
        id: String, 
        videoIdParam: {
            type: String,
            default: null
        },
        sendCredit: {
            type: Boolean,
            default: false
        },
        club: {
            type: Object,
            default: null
        },
        theme: {
            type: String,
            default: 'is-info'
        },
        init: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ""
        }
    },
    components: {
        vSelect
    },
    computed: {
        videoAdmin: {
            get() {
                
                if (typeof(this.$store.getters.getUser)!="undefined" && this.$store.getters.getUser!=null)
                    if (typeof(this.$store.getters.getUser.adminSite)!="undefined") {
                        
                        return this.$store.getters.getUser.adminSite;
                    }
                        
                return false;
            }
            
        },
        creditOffer: {
            get() {
                var user = this.$store.getters.getUser;
                var indexVideoDisplay = this.videos.findIndex(videoItem=>videoItem.id === this.videoId);
               
               
                var returnCreditOffer = 0;
                if (indexVideoDisplay!=-1) {
                    if (typeof(this.videos[indexVideoDisplay].credit)!="undefined") {
                        if (this.videos[indexVideoDisplay].credit == "1") {
                            if (user!=null) {
                                if (typeof(user.videosCredit)=="undefined")
                                    returnCreditOffer = 1;
                                else {
                                    if (user.videosCredit.indexOf(this.videoId) == -1)
                                        returnCreditOffer = 1;
                                }
                            }
                        }
                    }
                }
                return returnCreditOffer;
               // if (typeof(user.videoCredits)=="undefined")
            }
        }
    },
    data() {
        return {
            classModal: "modal",
            chapitres : [
            
            ],
            videoDisplay: null,
            videoId: null,
            videos: [],
            playerVars: {
                autoplay: 0,
                host: 'https://www.youtube.com',
                autohide: 0,
                fs: 1,
                modestbranding: 0,
                color: 'white',
                iv_load_policy: 3,
                cc_load_policy: 1,
                rel: 0,
                showinfo:1,
                controls:1
            },
            name: "",
            video: {
                idYouTube: "",
                title: "",
                titleBouton: "",
                chapitre: null
            },
            open: false,
            display: false,
            ecouleTime: 20,
            intervalId: null
            
        }
    },
    mounted() {
        this.refreshVideoId();
        var user = this.$store.getters.getUser;
       
        if (this.init)
            this.open = true;
        if (this.club!=null)
            if (typeof(this.club.videos)!="undefined")
                if (typeof(this.club.videos[this.id])=="undefined")
                    if (!this.open)
                        this.open=true;
    },
    watch: {
        init: function(val) {
            this.open = this.init;
        },
        open: function(val) {
            if (val)
                this.classModal = "modal is-active";
            else
                this.classModal = "modal";
            if (val)
                this.refreshVideoId();
          
        },
       
        club: function(val) {
            if (this.club!=null)
                if (typeof(this.club.videos)!="undefined")
                    if (typeof(this.club.videos[this.id])=="undefined")
                    if (!this.open)
                        this.open=true;
        }
    },
    methods: {
        openVideo() {
            this.open = true;
        },
        playing() {
            if (this.creditOffer && this.sendCredit) {
                this.ecouleTime = this.ecouleTime - 1;
                if (this.ecouleTime > 0) {
                    this.intervalId = setTimeout(() => {
                        this.playing();
                    }, 1000);
                }
                else
                   this.$emit("sendCredit");
            }
            
        },
        paused() {
            if (this.creditOffer && this.sendCredit) 
                clearTimeout(this.intervalId);
        },
        ended() {
            
        },
        up(index) {
            var video = this.videos[index];
             this.videos.splice(parseInt(index), 1);
            this.videos.splice(parseInt(index)-1, 0, video);
            var videos = {
                    videos: this.videos
                }
            firebase_api.api.getDb().collection("videos").doc(this.id).set(
                    videos
                )
        },
        down(index) {
            var video = this.videos[index];
            this.videos.splice(index, 1);
             this.videos.splice(parseInt(index)+1, 0, video);
             var videos = {
                    videos: this.videos
                }
            firebase_api.api.getDb().collection("videos").doc(this.id).set(
                    videos
                )
        },
        saveChapitres() {
            var chapitres = {
                chapitres: this.chapitres
            }
            firebase_api.api.getDb().collection("videos").doc("chapitres").set(chapitres);
        },
         selectChapitre(index) {
             this.video.chapitre = index;
         },
         deleteChapitre(index) {
             this.chapitres.splice(index, 1);
             this.saveChapitres();
         },
         addChapitre(param) {
             var chapitre = {
                 id: (new Date()).getTime(),
                 label: param
             }
             this.chapitres.push(chapitre);
             this.saveChapitres();
         },
         closeModal() {
            // sauver les chapites
            this.saveChapitres();
        },
        refreshVideoId () {
            this.ecouleTime = 20;
           
            firebase_api.api.getDb().collection("videos").doc(this.id).get().then(doc=>{
               
                if (doc.exists) {
                    
                    if (typeof(doc.data().videos)!="undefined") {
                        this.videos = doc.data().videos;
                        this.name = doc.data().name;
                        
                        if (this.videos.length==1 || this.videoIdParam!=null) {
                            
                            if (this.videoIdParam!=null) {
                                var videoItem = this.videos.find(vid=>vid.id===this.videoIdParam);
                                this.videoId = videoItem.id;   
                                this.videoDisplay = videoItem.idYouTube; 
                            }
                            else {
                                this.videoId = this.videos[0].id;
                                this.videoDisplay = this.videos[0].idYouTube;
                            }
                        }
                        else {
                            this.videoDisplay = null;
                        }
                    }
                    this.display = true;
                    
                }
                else
                    this.display = this.videoAdmin;
            })
            firebase_api.api.getDb().collection("videos").doc("chapitres").get().then(doc=>{
                if (doc.exists) {
                    this.chapitres = doc.data().chapitres;
                }
            })
        },
        close() {
            if (typeof(this.$refs["youtube_"+this.id]) != "undefined")
                this.$refs["youtube_"+this.id].player.stopVideo();
            if (this.club!=null)
                if (typeof(this.club.demo)!="undefined")
                    if (this.club.demo) {
                        var videos = {}
                        if (typeof(this.club.videos)!="undefined") {
                            videos = this.club.videos;
                        }
                        videos[this.id] = true;
                        firebase_api.api.getDb().collection("club").doc(this.club.id).update({
                            videos: videos
                        })
                    }
            this.open=false;
            this.$emit("close");
        },
        deleteVideos() {
            if (confirm('Tu es sûr ?'))
              firebase_api.api.getDb().collection("videos").doc(this.id).delete();
        },
        editVideo(video) {
            this.video = JSON.parse(JSON.stringify(video));
        },
        deleteVideo(index) {
            this.videos.splice(index, 1);
            var videos = {
                    name: this.name,
                    videos: this.videos
                }
            firebase_api.api.getDb().collection("videos").doc(this.id).set(
                    videos
                ).then(()=>{
                    this.refreshVideoId();
                })
        },
        addVideo() {
            this.video = {
                    idYouTube: "",
                    title: "",
                    titleBouton: "",
                    chapitre: null
                }
        },
        saveNom() {
             var videos = {
                    name: this.name,
                    videos: this.videos
                }
                firebase_api.api.getDb().collection("videos").doc(this.id).set(
                    videos
                )
        },
        
        saveVideo() {
            if (this.video.idYouTube!="") {
                var indexVideo = this.videos.findIndex(elt=>elt.idYouTube===this.video.idYouTube);
                
                if (indexVideo == -1) {
                    this.video.id= uuidv4();
                    this.videos.push(JSON.parse(JSON.stringify(this.video)));
                }
                else {
                     this.videos[indexVideo] = JSON.parse(JSON.stringify(this.video));
                    if (typeof(this.videos[indexVideo].id)=="undefined")
                        this.videos[indexVideo].id = uuidv4();
                }
                var videos = {
                    name: this.name,
                    videos: this.videos
                }
                firebase_api.api.getDb().collection("videos").doc(this.id).set(
                    videos
                ).then(()=>{
                   
                    this.refreshVideoId();
                })
                this.video = {
                    idYouTube: "",
                    title: "",
                    titleBouton: "",
                    chapitre: null
                }
            }
            else {
                alert('ID YOU TUBE NON DEFINI');
            }
        },
        selectVideo(idVideo) {
            this.videoId = idVideo
            this.videoDisplay = this.videos.find(videoItem=>videoItem.id == idVideo).idYouTube;
        }
    }
}
</script>